/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Transfer } from 'antd';

class CustomTransfer extends React.PureComponent {
  static filterOption(inputValue, option) {
    return (
      option.name.toLocaleLowerCase('tr-TR').indexOf(inputValue.toLocaleLowerCase('tr-TR')) >= 0
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      targetKeys: props?.value || [],
      selectedKeys: [],
    };
  }

  handleChange = (nextTargetKeys) => {
    this.setState({ targetKeys: nextTargetKeys });
    this.triggerChange(nextTargetKeys);
  };

  handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    this.setState({ selectedKeys: [...sourceSelectedKeys, ...targetSelectedKeys] });
  };

  triggerChange = (changedValue) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange([...changedValue]);
    }
  };

  render() {
    const { targetKeys, selectedKeys } = this.state;
    return (
      <Transfer
        showSearch
        titles={['Tüm Yetkiler', 'Verilen Yetkiler']}
        targetKeys={targetKeys}
        selectedKeys={selectedKeys}
        className="custom-transfer"
        dataSource={this.props?.dataSource}
        onChange={this.handleChange}
        onSelectChange={this.handleSelectChange}
        filterOption={this.filterOption}
        render={(item) => item.name}
        rowKey={(row) => row.identifier}
      />
    );
  }
}

CustomTransfer.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  dataSource: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      identifier: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

CustomTransfer.defaultProps = {
  value: [],
  onChange: null,
};

export default CustomTransfer;
